import store from '@/store/store';
import { UserRole } from '@/bundles/App/types';

export const getIsSuperAdmin = () => ((store?.state?.userRoles as string[])?.includes(UserRole.super_admin) || false);
